<template>

 
      <v-card class="mx-auto mt-n2" width="500" >
        <v-overlay
          absolute
          class="d-flex flex-column text-center"
          opacity="0.35"
          z-index="1"
          :value="datosNew.length === 0"
        >
          <div>
            <v-progress-circular
              width="2"
              size="50"
              color="white"
              indeterminate
            >
              <v-icon size="30">mdi-timer-sand</v-icon>
            </v-progress-circular>
          </div>
          Cargando Datos...
        </v-overlay>
        <div
          v-if="datosNew.length !== 0"
          class="pa-2 d-flex justify-space-between"
        >
          <v-chip color="accent" label text-color="white">
            <v-icon left> mdi-cart-outline </v-icon>
            Compras
          </v-chip>
          <v-chip
            class="font-weight-bold transparent text-body-1 primary--text"
            label
            text-color="white"
          >
            {{
              `${format(ItemClienteInfoTCompras, 1)} ${
                simboloMoneda[tipoMoneda]
              }`
            }}
          </v-chip>
        </div>
        <div
          v-if="datosNew.length !== 0"
          class="pa-2 d-flex justify-space-between"
        >
          <v-chip color="primary" label text-color="white">
            <v-icon left>mdi-credit-card-marker </v-icon>
            Pagos
          </v-chip>
          <v-chip
            class="font-weight-bold transparent text-body-1 primary--text"
            label
            text-color="white"
          >
            {{
              `${format(ItemClienteInfoTPagos, 1)} ${simboloMoneda[tipoMoneda]}`
            }}
          </v-chip>
        </div>
        <v-divider></v-divider>
        <v-virtual-scroll
          :bench="benched"
          :items="datosNew"
          height="490"
          item-height="98"
        >
          <template v-slot:default="{ item }">
            <v-list-item three-line :key="item.MesPro" dense>
              <v-list-item-content>
                <v-list-item-title
                  class="text-center text-body-2 font-weight-bold"
                >
                  <div>
                    {{ item.NombreMes }}
                  </div></v-list-item-title
                >
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span> Compras: </span>
                  <span class="font-weight-bold">
                    {{
                      `${format(item.Compras[tipoMoneda], 1)} ${
                        simboloMoneda[tipoMoneda]
                      }`
                    }}
                  </span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span> Pagos: </span>
                  <span class="font-weight-bold">
                    {{
                      `${format(item.Cobros[tipoMoneda], 1)} ${
                        simboloMoneda[tipoMoneda]
                      }`
                    }}
                  </span>
                </v-list-item-subtitle>

                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Doc Mora: </span>
                  <span class="font-weight-bold"> {{ `${item.DocMora}` }}</span>
                </v-list-item-subtitle>
                <v-list-item-subtitle class="d-flex justify-space-between">
                  <span>Promedio Mora: </span>
                  <span class="font-weight-bold">
                    {{ `${item.PromedMora}` }}
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
      </v-card>


</template>

<script>
import { format } from "../../static/funciones";
import { mapState } from "vuex";
export default {
  methods: {
    format,
  },
  computed: {
    ...mapState(["dsEstadistica", "simboloMoneda", "tipoMoneda"]),
    mesActual() {
      let fecha_mes = new Date()
        .toLocaleString("sv", { timeZoneName: "short" })
        .substr(0, 7);
      let arrayF = fecha_mes.split(["-"]);

      return parseInt(arrayF[1]);
    },
    ItemClienteInfoTPagos() {
      if (Object.entries(this.dsEstadistica).length !== 0) {
        let { ttestinfo: ttestinfo } = this.dsEstadistica.dsEstadistica;
        return ttestinfo[0].TPagos[this.tipoMoneda];
      }
    },
    ItemClienteInfoTCompras() {
      if (Object.entries(this.dsEstadistica).length !== 0) {
        let { ttestinfo: ttestinfo } = this.dsEstadistica.dsEstadistica;
        return ttestinfo[0].TCompras[this.tipoMoneda];
      }
    },

    datosNew() {
      let xDatos = [];
      if (Object.entries(this.dsEstadistica).length !== 0) {
        let { ttestcli: ttestcli } = this.dsEstadistica.dsEstadistica;
        if (ttestcli !== undefined) xDatos = ttestcli;
      }
      return xDatos.slice(0, this.mesActual);
    },
  },
  data() {
    return {
      benched: 0,
      headers: [
        {
          text: "Mes",
          align: "left",
          value: "NombreMes",
          width: "200px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold d-print-none",
        },
        {
          text: "Compras USD",
          width: "200px",
          align: "right",
          value: "Compras",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold",
        },
        {
          text: "Pagos USD",
          align: "right",
          value: "Cobros",
          width: "200px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold",
        },

        {
          text: "Doc Mora",
          align: "right",
          value: "DocMora",
          // width: "100px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold",
        },
        {
          text: "Promedio Mora",
          align: "right",
          value: "PromedMora",
          // width: "100px",
          sortable: false,
          divider: true,
          class: "black--text subtitle-1 font-weight-bold",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
